import styled from 'styled-components';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import COLORS from '../../../common/styles/color-pallete';

export const TabsWrapper = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  font-family: ${FONT_FAMILY.hellix.regular};

  .custom-tabs-buttons {
    font-family: ${FONT_FAMILY.hellix.regular};
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 28px;
    gap: 16px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: ${COLORS.lightShadedGrey};
  }
  .custom-tab-button {
    font-family: ${FONT_FAMILY.hellix.regular};
    cursor: pointer;
    padding: 0;
    border: none;
    background: none;
    outline: none;
    color: ${COLORS.textLightGrey};
  }
  .custom-tab-button.active {
    color: ${COLORS.brandPrimary};
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
    border-bottom: 2px solid ${COLORS.brandPrimary};
    margin-bottom: 2px;
  }
`;
